import { render } from "./SettingsAdmins.vue?vue&type=template&id=012daf5b&scoped=true"
import script from "./SettingsAdmins.vue?vue&type=script&lang=js"
export * from "./SettingsAdmins.vue?vue&type=script&lang=js"

import "./SettingsAdmins.vue?vue&type=style&index=0&id=012daf5b&scoped=true&lang=css"
import "./SettingsAdmins.vue?vue&type=style&index=1&id=012daf5b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012daf5b"]])

export default __exports__